import { Component, OnInit } from '@angular/core';
import {
  ColDef,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IServerSideDatasource,
  IServerSideGetRowsParams,
  SideBarDef,
  ModuleRegistry
} from 'ag-grid-community';

// Import required enterprise module
import { ServerSideRowModelModule } from 'ag-grid-enterprise';
import { FinancialsService } from 'src/app/services/modules/financials/financials.service';
import { TotalAmountComponent } from '../total-amount/total-amount.component';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { StatusBadgeComponent } from 'src/app/components/status-badge/status-badge.component';
import { SavedSearchComponent } from 'src/app/components/saved-search/saved-search.component';
import { ViewChild } from '@angular/core';

// Register the server-side row model module
ModuleRegistry.registerModules([ServerSideRowModelModule]);

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {
  @ViewChild('savedSearch') savedSearch!: SavedSearchComponent;
  public gridApi!: GridApi;

  public viewFilterType: string = 'provider-transactions';
  public module: string = 'financials';

  private searchSubject = new Subject<string>();
  private searchSub!: Subscription;
  searchText = '';

  constructor(
    private financialsService: FinancialsService,
  ) { }

  public sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: 'filters',
    hiddenByDefault: true,
  };

  public pagination = true;
  public paginationPageSize = 50;

  public gridOptions: GridOptions = {
    sideBar: this.sideBar,
    rowModelType: 'serverSide',
    cacheBlockSize: 50,
    maxBlocksInCache: 5,
    overlayLoadingTemplate: '<span class="border p-2">Select a project.</span>',
    headerHeight: 45,
    pagination: this.pagination,
    paginationPageSize: this.paginationPageSize,
    paginationAutoPageSize: false,
    paginationPageSizeSelector: [50, 100, 200, 500, 1000,],
    statusBar: {
      statusPanels: [
        { statusPanel: 'app-total-amount', align: 'left', statusPanelParams: { field: 'amount' } }
      ]
    },
    components: {
      'app-total-amount': TotalAmountComponent
    }
  }

  public columnDefs: ColDef[] = [
    {
      headerName: 'Amount($AUD)', field: 'amount', filter: 'agTextColumnFilter',
      cellClass: 'ag-right-aligned-cell',
      aggFunc: 'sum',
      valueFormatter: (params) => {
        // Check if the value is not null or undefined
        return params.value !== null && params.value !== undefined
          ? `$  ${params.value.toLocaleString()}`
          : '';
      },
    },
    {
      headerName: 'Paid out', field: 'paid_out', filter: 'agTextColumnFilter',
      valueFormatter: (params) => {
        return params.value === 1 ? 'Yes' : 'No';
      }
    },
    { headerName: 'Fee type', field: 'fee_type', filter: 'agTextColumnFilter' },
    {
      headerName: 'Job status',
      field: 'status',
      filter: 'agSetColumnFilter',
      filterParams: {
        // Get raw values directly from the data for the dropdown
        values: (params: any) => {
          const rawValues = params.api.getDisplayedRowAtIndex
            ? params.api.getDisplayedRowAtIndex // just to avoid TS lint errors
            : [];
          // Extract unique raw values
          const uniqueValues = new Set<string>();
          params.api.forEachNode((node: any) => {
            if (node.data?.status) {
              uniqueValues.add(node.data.status);
            }
          });
          params.success(Array.from(uniqueValues)); // pass raw values to dropdown
        },
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          return params.value
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (c: string) => c.toUpperCase());
        }
      },
      filterValueGetter: (params: any) => params.data?.status, // raw value for backend
      valueFormatter: (params: any) => { // formatted for grid display
        if (!params.value) return '';
        return params.value
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (c: string) => c.toUpperCase());
      },
      cellRenderer: StatusBadgeComponent
    },
    { headerName: 'Listing ID', field: 'listing_id', filter: 'agTextColumnFilter' },
    { headerName: 'Booking ID', field: 'booking_id', filter: 'agTextColumnFilter' },
    { headerName: 'Description', field: 'description', filter: 'agTextColumnFilter' },
    { headerName: 'Customer ID', field: 'customer_id', filter: 'agTextColumnFilter' },
    { headerName: 'Bank ref', field: 'reference', filter: 'agTextColumnFilter' },
    { headerName: 'Collect from', field: 'collect', filter: 'agTextColumnFilter' },
    { headerName: 'Deliver to', field: 'deliver', filter: 'agTextColumnFilter' },

  ];

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 120,
    resizable: true,
    floatingFilter: true
  };

  ngOnInit() {

    this.searchSub = this.searchSubject.pipe(debounceTime(1000)).subscribe(query => {
      this.triggerSearch(query);
    });
  }




  // Grid ready hook
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    this.gridApi.setSideBarVisible(true);

    const datasource: IServerSideDatasource = {
      getRows: (rowParams: IServerSideGetRowsParams) => {
        console.log('filterModel', rowParams.request.filterModel);

        const startRow = rowParams.request.startRow ?? 0;
        const endRow = rowParams.request.endRow ?? 0;


        const page = Math.floor(startRow / this.paginationPageSize) + 1;

        console.log('page', page);


        const filterModel =
          rowParams.request.filterModel && Object.keys(rowParams.request.filterModel).length > 0
            ? JSON.stringify(rowParams.request.filterModel)
            : [];

        const sortModel =
          rowParams.request.sortModel && Object.keys(rowParams.request.sortModel).length > 0
            ? JSON.stringify(rowParams.request.sortModel)
            : [];

        this.financialsService.getProviderFinancialListing({
          page,
          pageSize: this.paginationPageSize,
          sortModel: sortModel,
          filterModel: filterModel
        }).subscribe({
          next: (res: any) => {
            rowParams.success({ rowData: res.data, rowCount: res.total });

          },
          error: () => rowParams.fail()
        });
      }
    };

    this.gridApi.setGridOption('serverSideDatasource', datasource);
    if (this.savedSearch) this.savedSearch.refresh(this.gridApi);
  }

  onColumnChange(event: any) {
    if (this.savedSearch) {
      this.savedSearch.handleGridEvent(event);
    }
  }

  clearFiltersExternally() {
    this.searchText = '';
  }

  setSideBarVisible(value: boolean) {
    this.gridApi.setSideBarVisible(value);
  }

  searchByDescriptionEvent(event: any) {
    const input = (event.target as HTMLInputElement).value;
    this.searchText = input;

    if (event.key === 'Enter') {
      this.triggerSearch(input); // Trigger immediately on Enter
    } else {
      this.searchSubject.next(input); // Debounce otherwise
    }
  }

  triggerSearch(query?: string) {
    const searchQuery = query ?? this.searchText;

    // Update AG Grid filter model with description filter
    const filterModel = this.gridApi.getFilterModel();

    if (searchQuery) {
      filterModel['description'] = {
        filterType: 'text',
        type: 'contains',
        filter: searchQuery
      };
    } else {
      delete filterModel['description']; // Remove filter if empty
    }

    // Set new filter model
    this.gridApi.setFilterModel(filterModel);
    this.gridApi.onFilterChanged(); // Trigger server call with updated filters
  }

  clearSearch() {
    this.searchText = '';
    this.triggerSearch();
  }

  exportCsv() {
    // Call backend API to get all data without filters
    this.financialsService.getProviderFinancialListing({
      page: 1,
      pageSize: 0, // use 0 or a special value to request all rows
      sortModel: '[]', // optional: reset sorting
      filterModel: '{}' // reset filters
    }).subscribe({
      next: (res: any) => {
        const data = res.data;

        // Get visible column definitions from AG Grid
        const visibleColumns = this.gridApi.getColumnDefs()?.filter((col: any) => !!col.field);

        // Convert JSON data to CSV using column headers from the grid
        const csvContent = this.convertToCsv(data, visibleColumns as ColDef[]);

        // Trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'transactions.csv');
        link.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Failed to export CSV', err);
      }
    });
  }

  /** Convert JSON array to CSV string using column headers from AG Grid */
  private convertToCsv(objArray: any[], columnDefs: ColDef[]): string {
    if (!objArray || !objArray.length) return '';

    const csvRows: string[] = [];

    // Header row — use AG Grid header names
    const headers = columnDefs.map(col => {
      // Fallback to field name if headerName is missing
      return `"${(col.headerName || col.field || '').replace(/"/g, '""')}"`;
    });
    csvRows.push(headers.join(','));

    // Data rows — use column field mapping for correct order
    for (const row of objArray) {
      const values = columnDefs.map(col => {
        const val = row[col.field || ''] ?? '';
        if (typeof val === 'string') {
          return `"${val.replace(/"/g, '""')}"`; // escape quotes
        }
        return val;
      });
      csvRows.push(values.join(','));
    }

    return csvRows.join('\r\n');
  }


}
